import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { useBreadcrumb } from "../../context/BreadcrumbContext";
import { dateTimeFormatter } from "../../utils/dateTimeFormatter";
import { useDashboard } from "../../context/DashboardContext";

const Breadcrumb = () => {
  const { analysisSubType } = useBreadcrumb();
  const location = useLocation();
  const { dashboardData } = useDashboard();
  const [dateTime, setDateTime] = useState(new Date());

  const breadcrumbMap = {
    "system-analysis": `System Analysis${analysisSubType ? " - " + analysisSubType : ""}`,
    "engineering-drawings": "Engineering Drawings",
    "ndt-chart": "NDT Chart",
    "load-analysis": "Load Analysis",
    psm: "PSM",
    "doc-store": "Doc Store",
    reports: "Reports",
    calendar: "Calendar",
    contact: "Contact Us",
    drawing: "Drawings",
    "user-profile": "My Profile",
    "pipe-analysis": `Pipe Analysis${analysisSubType ? " - " + analysisSubType : ""}`,
    "user-management": "User Management",
    "user-access": "User Access",
    "user-preference": "User Preferences",
    "user-preference-widgets": "User Preference Widgets",
    "facility-management": "Facility Management"
  };

  const getDashboardTitleById = (id) => {
    const dashboard = dashboardData?.find((page) => page.pageId === parseInt(id));
    return dashboard?.pageTitle || null;
  };

  const generateBreadcrumb = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    return pathSegments.map((segment, index) => {
      const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
      const isLast = index === pathSegments.length - 1;

      let breadcrumbText;

      // First segment is "dashboard"
      if (segment === "dashboard") {
        breadcrumbText = "Dashboard";
      }
      // Second segment after dashboard
      else if (pathSegments[0] === "dashboard" && index === 1) {
        if (breadcrumbMap[segment]) {
          breadcrumbText = breadcrumbMap[segment];
        } else {
          breadcrumbText = getDashboardTitleById(segment) || segment;
        }
      }
      // All other routes
      else {
        breadcrumbText = breadcrumbMap[segment] || segment;
      }

      return (
        <span key={path}>
          {index > 0 && " / "}
          {isLast ? (
            <span className="fnt13 fw-500 decoration-none">{breadcrumbText}</span>
          ) : (
            <Link to={path} className="fnt13 fw-500 breadcrumb-text-decoration">
              {breadcrumbText}
            </Link>
          )}
        </span>
      );
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <hr className="mb-0 mt-0" />
      <div className="py-2 px-4 d-flex align-items-center justify-content-between">
        <div className="fnt14 fw-500">{generateBreadcrumb()}</div>
        <div className="fnt12 fw-500">{dateTimeFormatter(dateTime)}</div>
      </div>
      <hr className="mt-0" />
    </div>
  );
};

export default Breadcrumb;
